import React from 'react';
import DialogActions from '@material-ui/core/DialogActions';

const DialogAppActions = ({ children }) => {
  return (
    <DialogActions>
      {children}
    </DialogActions>
  );
};

export default DialogAppActions;



// WEBPACK FOOTER //
// ./src/components/DialogApp/components/DialogAppActions/DialogAppActions.jsx